import { atom } from 'jotai';

let innerHeightAtom = atom(window.innerHeight);

export { innerHeightAtom }
